import { Directive, Host, OnInit, Self } from '@angular/core';
import { map } from 'rxjs/operators';

import { ProviderSearchService } from '@assess/browser/data-mart-api';
import { trackByFunctions } from '@assess/browser/track-by-functions';
import { IProviderSource } from '@assess/shared/data-mart';
import { IProviderSearchBody, SearchBody } from '@assess/shared/data-mart-search';

import { displayWithFn, LookupSearchComponent } from '../../components/lookup-search/lookup-search.component';
import { trySetProp } from '../try-set-prop';

@Directive({
  selector: 'assess-lookup-search[assessProviderSearch]',
})
export class ProviderSearchDirective implements OnInit {
  readonly searchBodyFilters: IProviderSearchBody['filters'] = { active: true, exists: ['Name', 'NPI', 'ProviderID'] };
  readonly searchInputEmptyMessage = 'No matching providers found';
  readonly searchInputLabel = 'Provider';
  readonly searchInputPlaceholder = 'Search by provider name or NPI...';
  readonly searchResultTrackBy = trackByFunctions.by('ProviderID');

  constructor(
    private readonly providerSearchService: ProviderSearchService,
    @Host() @Self() private searchComponent: LookupSearchComponent
  ) {}

  readonly commonDisplayWith: displayWithFn = (value: IProviderSource) => {
    if (!value) {
      return '';
    }

    return `${value?.Name ?? 'No provider name'} (${value?.NPI ?? 'No provider NPI'})`;
  };

  readonly searchWith: LookupSearchComponent['searchWith'] = (body: SearchBody) => {
    return this.providerSearchService.search(body).pipe(map((result) => result.records));
  };

  ngOnInit() {
    trySetProp(this.searchComponent, 'selectionDisplayWith', this.commonDisplayWith);

    trySetProp(this.searchComponent, 'searchBodyFilters', this.searchBodyFilters);
    trySetProp(this.searchComponent, 'searchInputEmptyMessage', this.searchInputEmptyMessage);
    trySetProp(this.searchComponent, 'searchInputLabel', this.searchInputLabel);
    trySetProp(this.searchComponent, 'searchInputPlaceholder', this.searchInputPlaceholder);
    trySetProp(this.searchComponent, 'searchResultDisplayWith', this.commonDisplayWith);
    trySetProp(this.searchComponent, 'searchResultTrackBy', this.searchResultTrackBy);
    trySetProp(this.searchComponent, 'searchWith', this.searchWith);
  }
}
